import React from 'react'
import { connect, ConnectedProps } from 'react-redux';
import { Dispatch } from 'redux';
import { authSelectors } from 'redux/app/auth';
import { IStore } from 'redux/store';


type TActionMenuProps = {
	onClickView: () => void;
	onClickDownload: () => void;
	onClickTools?: () => void;
	report?: any;
	rowSpan?: number;
}
function ActionMenu(props: TActionMenuProps & PropsFromRedux) {
	const {
		onClickDownload,
		onClickView,
		onClickTools,
		report,
		rowSpan,
		isUserAllowedToUseCNRTool,
	} = props;
	return (
		<>
			<td rowSpan={rowSpan} className="cursor-default border text-[9px] md:text-[12px] xl:text-sm text-gray-600 pl-2 min-w-10 lg:min-w-32 sticky z-1 -right-2 bg-white">
				<div className="flex gap-4 justify-center items-center">
					{/* TODO: Implement print view */}
					<span
						className="bp3-icon bp3-icon-eye-open text-xs lg:text-lg cursor-pointer"
						title='view'
						onClick={onClickView}
					/>
					{/* TODO: Download isn't implemented yet */}
					{/* <span
						className="bp3-icon bp3-icon-import text-sm lg:text-lg cursor-pointer"
						onClick={onClickDownload}
					/> */}
					{isUserAllowedToUseCNRTool &&
						<span
							className="bp3-icon bp3-icon-wrench text-xs lg:text-lg cursor-pointer"
							title='tools'
							onClick={onClickTools}
						/>
					}
				</div>
			</td>
		</>
	)
}


function mapStateToProps(store: IStore) {
	const isUserAllowedToUseCNRTool = authSelectors(store.app.auth).isUserAllowedToUseCNRTool();

	return {
		isUserAllowedToUseCNRTool,
	};
}

function mapDispatchToProps(dispatch: Dispatch) {
	return {}
}

const reduxConnector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof reduxConnector>;
export default reduxConnector(ActionMenu);